import {
    GetLotIdsQuerySchema,
    GetOccupancyByLotIdQuerySchema,
    GetOccupancyByLotIdVariablesSchema,
    GetScsDeviceCurrentValueQuerySchema,
    GetScsDeviceCurrentValueVariablesSchema,
    GetStationByParkingLotQuerySchema
} from '../lot_schemas'
import { useEffect, useMemo, useState } from 'react'
import { useApi, useDataFetcher } from '../../../utils'

export const useGetStationByParkingLot = (lotSectionId: string | undefined | null) => {
    const result = useDataFetcher(
        'get_station_by_parking_lot',
        { lot_section_id: lotSectionId },
        GetStationByParkingLotQuerySchema,
        {
            queryKey: ['data_fetcher', 'get_station_by_parking_lot', lotSectionId],
            enabled: !!lotSectionId,
            staleTime: 0,
            cacheTime: 0
        }
    )

    return { data: result.data, refetch: result.refetch, loading: result.isFetching }
}

export const useGetLotList = () => {
    const result = useDataFetcher('get_lot_ids', {}, GetLotIdsQuerySchema, {
        queryKey: ['data_fetcher', 'get_lot_ids']
    })

    return { data: result.data, refetch: result.refetch, loading: result.isFetching }
}

export const useGetOccupancyByLotId = (lotId: string | undefined | null) => {
    const [lastFetchOccupancy, setLastFetchOccupancy] = useState<Date | undefined>(undefined)
    const variables = useMemo(
        () => (lotId ? GetOccupancyByLotIdVariablesSchema.parse({ lot_ids: [lotId] }) : undefined),
        [lotId]
    )
    const result = useApi('/occupancy/get_occupancy_by_lot', variables, GetOccupancyByLotIdQuerySchema, {
        queryKey: ['occupancy/get_occupancy_by_lot', variables],
        enabled: !!variables,
        refetchInterval: 30000,
        refetchOnWindowFocus: false
    })
    const first = result.data?.[0]

    useEffect(() => {
        if (first && !result.isFetching) {
            setLastFetchOccupancy(new Date())
        }
    }, [first, result.isFetching])

    return {
        data: first,
        refetch: result.refetch,
        loading: result.isFetching,
        lastFetchOccupancy
    }
}

export const useGetSCSDeviceCurrentValue = (device_space_id: string | undefined | null) => {
    const variables = useMemo(
        () => (device_space_id ? GetScsDeviceCurrentValueVariablesSchema.parse({ device_space_id }) : undefined),
        [device_space_id]
    )
    const result = useApi('/occupancy/get_scs_device_current_value', variables, GetScsDeviceCurrentValueQuerySchema, {
        queryKey: ['occupancy/get_scs_device_current_value', variables],
        enabled: !!variables,
        refetchInterval: 30000,
        refetchOnWindowFocus: false
    })

    return { data: result.data, refetch: result.refetch, loading: result.isFetching }
}
